import { render, staticRenderFns } from "./PostsCarousel.vue?vue&type=template&id=5d381012"
import script from "./PostsCarousel.vue?vue&type=script&lang=js"
export * from "./PostsCarousel.vue?vue&type=script&lang=js"
import style0 from "./PostsCarousel.vue?vue&type=style&index=0&id=5d381012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports